import { forwardRef, useImperativeHandle } from "react";

import { CompoundFormForwardedRef } from "./fieldBuilder";

export const EmptyCustomSection = forwardRef(
    (_props: object, ref: CompoundFormForwardedRef) => {
        useImperativeHandle(ref, () => {
            return {
                validate() {
                    return Promise.resolve({
                        type: "SUCCESS",
                        values: undefined,
                    });
                },
            };
        }, []);
        return null;
    }
);
